export const GET_BUSINESS_EST = 'OHP/get_business_est';
export const GET_SINGLE_BUSS_EST = 'OHP/get_single_buss_est';
export const UPDATE_BUSSINESS_EST = 'OHP/update_business_est';
export const CREATE_BUSSINESS_EST = 'OHP/create_business_est';
export const REMOVE_BUSSINESS_EST = 'OHP/remove_business_est';

export const FORM_DATA = {
  name: '',
  address: '',
  is_active: '',
};
